import { render, staticRenderFns } from "./ExpandableSidebar.vue?vue&type=template&id=386dcc68&scoped=true&"
import script from "./ExpandableSidebar.vue?vue&type=script&lang=ts&"
export * from "./ExpandableSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableSidebar.vue?vue&type=style&index=0&id=386dcc68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386dcc68",
  null
  
)

export default component.exports